//#region src/generated/locales/de.ts
var templates = {
	"pd.contactus.address.name": `Name`,
	"pd.contactus.address.email": `Email`,
	"pd.contactus.address.phone": `Telefon`,
	"pd.contactus.address.message": `Nachricht`,
	"pd.contactus.address.send": `Absenden`,
	"pd.footer.nav.aria": `Footer Navigation`,
	"pd.footer.social.aria": `Social Media`,
	"pd.footer.legal.aria": `Legal Navigation`,
	"pd.login.email.label": `E-Mail`,
	"pd.login.password.label": `Passwort`,
	"pd.login.forgot.password": `Passwort vergessen?`,
	"pd.login.submit": `Anmelden`,
	"pd.login.forgot.info": `Geben Sie Ihre E-Mail-Adresse ein. Sie erhalten einen Link zum Zurücksetzen Ihres Passworts.`,
	"pd.login.forgot.back": `Zurück zur Anmeldung`,
	"pd.login.forgot.submit": `Link anfordern`,
	"pd.menu.nav.aria": `Hauptnavigation`,
	"pd.menu.locale.aria": `Sprache auswählen`,
	"pd.menu.burger.aria": `Menü öffnen`,
	"pdPage.toast.ariaClose": `Schließen`
};
//#endregion
export { templates };
